<template>
    <div class="card border-0 border-light shadow">
        <div class="card-body">
            <p class="step-content-question-inputs-text card-text form-inline">
                <span v-for="(part, index) in splitQuestion">
                    <span v-html="part"></span>
                    <!-- TODO: use contenteditable span and bind the value with the hidden input (not sure about browser support though...) -->
<!--                    <span role="textbox" contenteditable=""></span>-->
                    <input required autocomplete="off" type="text" :value="valueLocal['part' + (index + 1)]" :placeholder="placeholder(index)" v-on:input="onInput($event, index)"
                           class="question-gap text-body form-control form-control-sm mx-1 py-0 fs-0 border border-dark border-bottom align-baseline border-left-0 border-top-0 border-right-0"  onclick="this.select()">
                </span>
                <span>{{ last }}</span>
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                last: '',
                gaps: {}
            }
        },

        props: {
            question: Object,
            index: Number,
            value: Object
        },

        computed: {
            valueLocal: {
                get: function() {
                    return this.value
                },
                set: function(value, index) {
                    console.log('-------------------------')
                    console.log(value)
                    console.log(index)
                    console.log('-------------------------')
                    //this.$emit('input', value)
                }
            },

            splitQuestion() {
                let reg = /\#.*?\#/g
                let text = this.question.text.split(reg)
                this.last = text.pop()
                return text
            }
        },

        methods: {
            onInput($event, index) {
                let value = $event.target.value
                this.$emit('input', {questionId: this.question.id, part: 'part' + (index + 1), value: value})
            },

            placeholder(index) {
                if (this.question.variants && this.question.variants[index]) {
                    return this.question.variants[index].text + '...'
                }

                return '';
            }
        }
    }
</script>
